const API = "https://flautreach.com/flautreach/api";

export const apiService = {

  async login(email, password) {
  const response = await fetch(`${API}/auth/login/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  if (!response.ok) {
    const data = await response.json();
    const err = new Error(data.detail || "Login failed");
    err.code = data.code; // ← добавить эту строку
    throw err;
  }
  return response.json();
},
  


  async getMe(token) {
    const response = await fetch(`${API}/users/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error("Unauthorized");
    return response.json();
  },

  async getKeywords(token) {
    const response = await fetch(`${API}/get_my_keywords`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error("Failed to fetch");
    return response.json();
  },

  async addKeyword(token, data) {
    const response = await fetch(`${API}/add_keyword`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.detail || "Failed to add");
    }
    return response.json();
  },

  async toggleKeyword(token, id, enable) {
    const endpoint = enable ? "activate_keyword" : "pause_keyword";
    const response = await fetch(`${API}/${endpoint}/${id}`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error("Toggle failed");
    return response.json();
  },

  async deleteKeyword(token, id) {
    const response = await fetch(`${API}/delete_keyword/${id}`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error("Delete failed");
    return response.json();
  },

  async support(token, message) {
    const response = await fetch(`${API}/support/`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ message }),
    });
    if (!response.ok) throw new Error("Failed");
    return response.json();
  },

  async forgotPassword(email) {
    const response = await fetch(`${API}/auth/forgot-password/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });
    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.detail || "Failed");
    }
    return response.json();
  },

  async resendVerification(token) {
    const response = await fetch(`${API}/auth/resend-verification/`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) throw new Error("Failed");
    return response.json();
  },

  async openTariffs(token) {
    await fetch(`${API}/open_tariffs`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}),
    });
  },

  async chooseTariff(token, id) {
    await fetch(`${API}/choose_tariffs`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id }),
    });
  },

  register: async (email, pass, pass2, tracking = {}) => {
    const response = await fetch(`${API}/auth/register/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email,
        password1: pass,
        password2: pass2,
        referral_code: tracking.referral_code || '',
        utm: tracking.utm || '',
        locale: tracking.locale || 'en', // локаль
      }),
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Registration failed');
    }
    
    return response.json();
  },

  googleAuth: async (idToken, tracking = {}) => {
    const response = await fetch(`${API}/auth/google/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id_token: idToken,
        referral_code: tracking.referral_code || '',
        utm: tracking.utm || '',
        locale: tracking.locale || 'en', // локаль
      }),
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Google authentication failed');
    }
    
    return response.json();
  },

   verifyEmail: async (token) => {
    const response = await fetch(`${API}/auth/verify-email?token=${token}`, {
      method: 'GET',
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Email verification failed');
    }
    
    return response.json();
  },

  // services/api.js

resetPassword: async (token, newPassword) => {
  const response = await fetch(`${API}/auth/reset-password/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      token: token,
      new_password: newPassword,
    }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Password reset failed');
  }

  return response.json();
},

// services/api.js

resendVerification: async (email) => {
  const response = await fetch(`${API}/auth/resend-verification/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to resend verification');
  }

  return response.json();
},

};